// utils/demoGroupsData.js
export const getDemoGroupsData = () => {
    // Cleared for real products - will be populated from database
    return [];
};

// Keep any helper functions if they exist
export const enhanceGroupWithDynamicData = (group) => {
    const now = Date.now();
    return {
        ...group,
        endDate: group.endDate || new Date(now + (group.daysLeft * 24 * 60 * 60 * 1000)),
        progress: group.progress || Math.floor((group.currentCount / group.targetCount) * 100)
    };
};
